// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"5500158d","453":"a9fafe1c"}[chunkId] + ".chunk.js";
};